exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* #average-chart .apexcharts-text {\n  font-size: 1.75em;\n} */\n", ""]);

// exports
